import { useState, MutableRefObject, useRef, useEffect } from "react"
import { HexMap } from "../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../Data/HexMap/HexMapModifier"
import {produce, WritableDraft} from "immer";
import { Note } from "../../Data/HexMap/Note";
import { HxMapGroup } from "./HxMapGroup";
import { TransformTranslate } from "../../Util/Transform/Transform";
import { All } from "../../Util/Constants/Quantities";
import { Key } from "../../Data/HexMap/Key";

export function HxChildMap(props:{
        height:number,
        width:number,
        tonic:number,
        radius:number,
        hilitedNotes:number[], 
        definedNotes?:number[],
        selectedNotes?:number[],
        onNoteClick?:Function,
        onNoteCtrl?:Function
        onKeyClick?:Function,
        singleSelect?:boolean
    }){
    const onNoteClick = (note:Note, e:React.MouseEvent, ctrl?:boolean) => {
        const selectedState:number = (note.selectedState == Note.SelectedState_Default) ? Note.SelectedState_Selected : Note.SelectedState_Default
        if(props.onNoteClick){ props.onNoteClick(note, e, ctrl); return}
            setMap(produce((draft)=>{
                mod.current.setDraft(draft)
                if(props.singleSelect){
                    mod.current.notes_setSelectedState([All], Note.SelectedState_Default)
                }
                mod.current.notes_setSelectedState([note.params.noteIndex], selectedState)
            }))
    }
    const onKeyClick = (key:Key) =>{
        if(props.onKeyClick){props.onKeyClick(key); return}
    }
    const getMap = () => {
        const params:HexMapBuilderParams = {
            rows:1, columns:1, tonic:props.tonic, radius:props.radius
        }
        const map:HexMap = BuildHexMap(params)
        if(props.definedNotes && props.definedNotes.length === 0){
            map.notes.forEach((note:Note)=>{
                note.defined = false
            })
        }
        return map
    }
    const [map, setMap] = useState(getMap())
    const mod:MutableRefObject<HexMapModifier> = useRef(new HexMapModifier(map))
    const updateMap = () => {
            setMap(produce((draft)=>{
                mod.current.setDraft(draft)
                mod.current.notes_setSelectedState([All], Note.SelectedState_Default)
                mod.current.notes_setSelectedState(props.hilitedNotes, Note.SelectedState_Hilited)
                if(props.selectedNotes){
                    mod.current.notes_setSelectedState(props.selectedNotes, Note.SelectedState_Selected)
                }
                mod.current.setTonic(props.tonic)
            }))
    }
    useEffect(updateMap, [props.hilitedNotes, props.definedNotes, props.tonic])
    return(
        <div>
            <svg width={props.width} height={props.height}>
                <g transform={TransformTranslate(props.width/2,props.height/2)}>
                    <HxMapGroup hexMap={map} onKeyClick={onKeyClick} onNoteClick={onNoteClick}/>
                </g>
            </svg>
        </div>
    )
}